<template>
<div class="pa-6">
    <v-row>
      <v-col cols="12" md="6">
        <ChangePasswordCard class="h-100" />
      </v-col>
      <v-col cols="12" md="6">
        <v-card class="h-100" outlined flat>
          <v-card-text class="pa-4">
            <h3 class="primary--text mb-4">{{ $t('profile.devices.devices') }}</h3>
            <div v-if="devices && devices.length > 0">
              <div
                v-for="device in devices"
                :key="device.id"
                class="d-flex rounded grey pointer lighten-4 py-2 px-4 mb-2"
                @click="edit(device)"
              >
                <span>{{ device.name }}</span>
                <v-icon class="ml-auto" small @click.stop="remove(device)">
                  mdi-window-close
                </v-icon>
              </div>
            </div>
            <div v-else>
              <p>{{ $t('profile.devices.noDevices') }}</p>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <Confirm ref="confirm" />
    <update-device
      v-if="updateDialog"
      :dialog="updateDialog"
      :device="selectedDevice"
      :loading="loadingDialog"
      @cancel="updateDialogCancel"
      @submit="updateDialogSubmit"
    ></update-device>
  </div>
</template>

<script>
import Service from '@/services'
import ChangePasswordCard from '@/components/cards/ChangePasswordCard.vue'
import UpdateDevice from '../dialogs/UpdateDevice.vue'
import Confirm from '@/components/dialogs/Confirm.vue'

export default {
  name: 'Devices',
  components: {
    ChangePasswordCard,
    UpdateDevice,
    Confirm
  },
  data () {
    return {
      devices: null,
      selectedDevice: null,
      loadingDialog: false,
      updateDialog: false
    }
  },
  created () {
    this.getDevices()
  },
  methods: {
    async getDevices () {
      try {
        const { data } = await Service.get('/Device/GetMyDevices')
        this.devices = data
      } catch (e) {}
    },
    edit (device) {
      this.selectedDevice = device
      this.updateDialog = true
    },
    async remove (device) {
      this.loadingDialog = true
      if (await this.$refs.confirm.open(this.$t('profile.devices.removeChange'), this.$t('profile.devices.title'))) {
        try {
          await Service.delete('/Device/DeleteDevice', {
            deviceId: device.deviceId
          })
          this.getDevices()
          await this.$store.dispatch('setSuccessNotification', this.$t('profile.devices.remove'))
        } catch (e) {}
      }
      this.loadingDialog = false
    },
    async updateDialogSubmit (name) {
      this.loadingDialog = true
      try {
        await Service.put('/Device/UpdateDevice', {
          deviceId: this.selectedDevice.deviceId,
          name: name
        })
        this.updateDialog = false
        this.getDevices()
        await this.$store.dispatch('setSuccessNotification', this.$t('profile.devices.updateChange'))
      } catch (e) {}
      this.loadingDialog = false
    },
    updateDialogCancel () {
      this.updateDialog = false
      this.selectedDevice = null
    }
  }
}
</script>

<style>
</style>
